const joinDefinedStringParts = (parts: (string | undefined | null)[], separator: string, defaultValue = ""): string =>
  parts.filter(Boolean).join(separator) || defaultValue;

export default joinDefinedStringParts;
